import { useEffect, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";

function AdminOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetch("https://kolibusiness.com/backend/admin-orders.php")
      .then((res) => res.json())
      .then((data) => setOrders(data))
      .catch((err) => console.error("Failed to fetch orders", err));
  }, []);

  if (!hasPermission("orders", "view")) {
    return (
      <AdminLayout>
        <p style={{ color: "red", padding: "20px", fontWeight: "bold" }}>
          ❌ You do not have permission to view orders.
        </p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <h2>📦 All Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order, i) => (
          <div
            key={i}
            style={{
              background: "#fff",
              padding: "15px",
              marginBottom: "20px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          >
            <h4>
              Order #{order.id} - {order.first_name} {order.last_name}
            </h4>
            <p><strong>Total:</strong> ₹{order.total}</p>
            <p><strong>Payment:</strong> {order.payment_method}</p>
            <p><strong>Address:</strong> {order.address}</p>
            <p><strong>Date:</strong> {order.created_at}</p>
            <h5>Items:</h5>
            <ul>
              {JSON.parse(order.cart).map((item, idx) => (
                <li key={idx}>{item.title} — ₹{item.price}</li>
              ))}
            </ul>
          </div>
        ))
      )}
    </AdminLayout>
  );
}

export default AdminOrders;
